import bag2 from '../../assets/img/bags/image_2.png';
import bag6 from '../../assets/img/bags/image_6.png';

const lastSeasonCollections = [
    {
        id: '1',
        img: bag2,
        title: 'Convertible Mini Merinal',
    },
    {
        id: '2',
        img: bag6,
        title: 'Smart Mike Laural Bag',
    },
    {
        id: '3',
        img: bag6,
        title: 'Convertible Mini Merinal',
    },
    {
        id: '4',
        img: bag2,
        title: 'Lorem Lorem Flick Lorem',
    },
    {
        id: '5',
        img: bag6,
        title: 'Lorem Flick Flick Flick',
    },
];

export default lastSeasonCollections;
